__turbopack_context__.v({
  "container": "FormFileUpload-module-scss-module__LEhy6W__container",
  "containerWithFile": "FormFileUpload-module-scss-module__LEhy6W__containerWithFile",
  "hiddenInput": "FormFileUpload-module-scss-module__LEhy6W__hiddenInput",
  "iconWrapper": "FormFileUpload-module-scss-module__LEhy6W__iconWrapper",
  "uploadButton": "FormFileUpload-module-scss-module__LEhy6W__uploadButton",
});
